// import website from '../assets/website.png'
import PPDB from '../assets/PPDB.svg'
import smk1 from '../assets/SMK1.png'
import smk2 from '../assets/SMK2.png'
// import lmsbudut from '../assets/LMSBUDUT.png'
import instagram from '../assets/instagram.png'
import facebook from '../assets/Facebook.png'
import youtube from '../assets/youtube.jpeg'
import profesi from '../assets/profesi.svg'

const items = [
{
    "title": "Formulir Pendaftaran Siswa Baru",
    "subtitle": "Akses Ke Formulir pendaftaran Siswa Baru SMK Budi Utomo Way Jepara",
    "image": PPDB,
    "link": "https://daftar.budutwj.com/daftar" //your personal website or portfolio  link
},
{
    "title": "SMK 1 Budi Utomo",
    "subtitle": "Akses Ke Web SMK S 1 Budi Utomo Way Jepara",
    "image": smk1,
    "link": "https://smkbudiutomowj.sch.id/" //your personal website or portfolio  link
},
{
    "title": "SMK 2 Budi Utomo",
    "subtitle": "Akses Ke Web SMK S 2 Budi Utomo Way Jepara",
    "image": smk2,
    "link": "https://smkbudiutomo2wj.sch.id/" //your personal website or portfolio  link
},
// {
//     "title": "LMS Budi Utomo",
//     "subtitle": "Mulai Belajar Mandiri, Tingkatkan Potensi",
//     "image": lmsbudut,
//     "link": "https://lms.budiutomo.sch.id/" //your personal website or portfolio  link
// },
{
    "title": "Instagram",
    "subtitle": "Follow untuk Akses Event & Info Menarik Dari SMK Budi Utomo Way Jepara 😉",
    "image": instagram,
    "link": "https://www.instagram.com/smkbudiutomowayjepara/" //instagram profile link 
},
{
    "title": "Facebook",
    "subtitle": "Follow untuk Akses Event & Info Menarik Dari SMK Budi Utomo Way Jepara 😉",
    "image": facebook,
    "link": "https://www.facebook.com/smkbudiutomowayjepara"// facebook profile link 
},
{
    "title": "YouTube",
    "subtitle": "Subscribe untuk Tonton Konten Menarik Dari SMK Budi Utomo Way Jepara 😉",
    "image": youtube,
    "link": "https://www.youtube.com/channel/UCkyRvjQoOXKtnfobSmiFjQw"//youtube channel link 
},
{
    "title": "Profesi.com",
    "subtitle": "Cari Lowongan Pekerjaan",
    "image": profesi,
    "link": "https://profesi.com/" //your personal website or portfolio  link
},
]

export default items
